export default __webpack_public_path__ + "static/media/w03.9db265c7.svg";